import { StyleProp, ViewStyle } from "react-native";
import { useTheme } from "react-native-paper";
import Svg, { Path } from "react-native-svg";

type Props = {
  style?: StyleProp<ViewStyle>;
  color?: string;
};

export default function SinpeMovil({ style, color }: Props) {
  const { colors } = useTheme();

  return (
    <Svg viewBox="0 0 400 400" width="24" height="24" style={style}>
      <Path
        id="sinpe"
        fill={color || colors.onSurfaceVariant}
        d="m386 61.5c56.3 63.1-124.6 287-124.6 287 0 0 136.8-196.7 74.2-243.6-62.6-46.9-189 72.8-189 72.8 0 0 183.1-179.4 239.4-116.2zm-365.4 282.8c-81.1-64 144.2-285.6 144.2-285.6 0 0-165.8 183.1-105 235.2 60.8 52 210-61.6 210-61.6 0 0-178.5 157.6-249.2 112z"
      />
    </Svg>
  );
}
